import { type FunctionComponent, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Stack from "@mui/material/Stack";
import { Loader } from "@carel-tools/carel-tools-react-component";
import { useNavigate } from "react-router";
import { userManager } from "../../../common/userManager.ts";
import { AppRoutes } from "../../../common/appRoutes.ts";

export const Redirect: FunctionComponent = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        userManager.signinCallback().then(() => {
            navigate(AppRoutes.Home);
        })
            .catch((error) => {
                console.error("Error handling callback:", error);
            });
    }, [navigate]);

    return (
        <Stack spacing={2}>
            <Loader
                message={t("label_redirect_to_sign_in_manager")}
                circularProgressPosition={"bottom"}
            />
        </Stack>
    );
}
